import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from "../../../../../../globals";
import { ProductsServices } from "../../../../services";

@Component({
  selector: 'page-product-partial-foodcost-tags',
  templateUrl: 'product-partial-foodcost-tags.html',
})
export class ProductPartialFoodcostTagsPage {
  show_product_tags = false;
  product_tags_filtered = [];

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public globals: Globals,
    public productsServices: ProductsServices) {

  }

  onChange(val) {
    this.productsServices.product_tags = val || [];
  }

  addTag(tag) {
    // Asegurar que product_tags sea un array
    if (!this.productsServices.product_tags) {
      this.productsServices.product_tags = [];
    }
    
    if (!(this.productsServices.product_tags.indexOf(tag) > -1)) {
      if (tag != 'eti') {
        this.productsServices.product_tags.push(tag);
        this.show_product_tags = false;
        this.product_tags_filtered = [];
      }
    }
  }

  onInputChange(event: any) {
    const valorInput = event.target.value;
    if (valorInput) {
      this.show_product_tags = true;
      this.product_tags_filtered = this.globals.tags_dishs.concat(this.globals.tags_products).filter(tag =>
        tag.toLowerCase().includes(valorInput.toLowerCase()));
      this.product_tags_filtered.sort((one, two) => (one < two ? -1 : 1));
    } else {
      this.show_product_tags = false;
    }
  }

}


// WEBPACK FOOTER //
// ./src/pages/products/product-create/product-create-foodcost/product-create-foodcost-info/product-partial-foodcost-tags/product-partial-foodcost-tags.ts